/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import "styles/components/section-link-cards.css";

const SectionLinkCardsSectionItem = (props) => {
    const card = props?.card;
    const icon = card?.icon;
    const link = card?.link;
    
    const img_url = icon?.url;
    const img_alt = icon?.alt || icon?.title || "Card icon";
    const link_url = link?.url;
    const link_text = link?.text || link?.title || "Learn More";
    const link_target = link?.target || "_blank";
    

    // TODO: use react-router-dom to navigate to the link based on the link type
    const handleClick = () => {
        if (link_url) {
            window.open(link_url, link_target);
        }
    };
    
    return (
        <Fragment>
            <div className="simplicity-section-link-cards-card">
                <div className="simplicity-section-link-cards-card-container">
                    {icon && (
                        <div className="simplicity-section-link-cards-icon">
                            <img
                                src={img_url}
                                alt={img_alt}
                            />
                        </div>
                    )}
                    
                    {link && (
                        <h4 className="simplicity-section-link-cards-link">
                            {link_text}
                        </h4>
                    )}
                </div>
            </div>
        </Fragment>
    );
};

export { SectionLinkCardsSectionItem };
